import React, { createContext, useEffect, useState, useContext } from 'react';

import { Button } from 'components/Button';
import { ModalGeneric } from 'components/ModalGeneric';

import popUpValidationError from 'assets/images/pop-up-blocked.gif';

import { StyledModalBody } from './styled';
// import { download } from 'utils/files';
import * as Sentry from '@sentry/react';
import { AuthContext } from 'context/AuthContext';
import { parseJwt } from 'utils/parse';
import { FiltersContext } from 'context/GlobalFiltersContext';

const SocketIoContext = createContext();
SocketIoContext.displayName = 'SocketIoContext';

const SocketIoProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { authContext } = useContext(AuthContext);
  const { headerFiltersContext } = useContext(FiltersContext);
  // const location = useLocation();
  const { companies, units } = headerFiltersContext?.headerFilters;
  // TODO: HOIST TO OWN PROVIDER OR EXPORT AND IMPORT IN APP
  useEffect(() => {
    const scope = Sentry.getCurrentScope();

    if (companies) {
      const croppedCompanyName = companies?.name?.split(' ')?.slice(0, 3)?.join(' ');
      scope.setTag('Empresa', companies?.id);
      scope.setTag('Empresa.nome', croppedCompanyName);
      scope.setTag('Empresa.tipo', companies?.tipoNome);
    }

    if (units) {
      scope.setTag('Unidade', units?.id);
      scope.setTag('Unidade.nome', units?.name);
    }
  }, [companies, companies?.name, companies?.id, units, units?.name, units?.id]);

  useEffect(() => {
    const scope = Sentry.getCurrentScope();
    if (authContext.isAuthenticated && authContext.token) {
      const { email, unique_name: username, nameid: userId, utyp: userType } = parseJwt(authContext.token);
      scope.setUser({ email, username, id: userId });
      scope.setTag('user.tipo', userType);
    } else {
      scope.clear();
    }
  }, [authContext.isAuthenticated, authContext.token, authContext.user]);

  return (
    <SocketIoContext.Provider
      value={
        {
          // socketIoContext: socketState,
          // setSocketIoContext: setSocketState
        }
      }
    >
      {children}
      <ModalGeneric
        open={isModalOpen}
        hasHeader={true}
        closeModal={() => setIsModalOpen(false)}
        size={{ maxWidth: '521px' }}
      >
        <StyledModalBody>
          <h6>Habilite os pop-ups para gerar relatórios</h6>
          <span>Para habilitar siga os passos abaixo:</span>
          <img src={popUpValidationError} alt="Pop-up bloqueada" />
          <Button type="button" onClick={() => setIsModalOpen(false)}>
            Entendi
          </Button>
        </StyledModalBody>
      </ModalGeneric>
    </SocketIoContext.Provider>
  );
};

export { SocketIoContext, SocketIoProvider };
